import { api } from "../api";

/**
 * findAllReportsListResponse - Function that finds on database all reports suported select list response  
 * /reports  
 * method GET 
 * @async-function
 */
const findAllReportsListResponse = async (token: string) => {
    const response = await api.get(
        `/reports`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllReportsListResponse;